type FontSizeIndex = 4 | 5 | 6 | 7 | 8 | 9;
type FontSizeSteps = {
    desktop: Record<FontSizeIndex, string>;
    mobile: Record<FontSizeIndex, string>;
};

export class FontSizeService {
    private isMobile: boolean;
    private readonly FONT_SIZE_STEPS: FontSizeSteps = {
        desktop: {
            4: '48px',
            5: '40px',
            6: '40px',
            7: '32px',
            8: '32px',
            9: '24px',
        },
        mobile: {
            4: '40px',
            5: '32px',
            6: '32px',
            7: '24px',
            8: '24px',
            9: '17px',
        },
    };

    constructor() {
        if (__isBrowser__ && typeof window !== 'undefined' && window.matchMedia) {
            const mediaQueryList = window.matchMedia('(max-width: 720px)');
            this.isMobile = mediaQueryList.matches;
        } else {
            this.isMobile = false;
        }
    }

    calc(value1?: number | string | null, value2?: number | string | null): string {
        const trunc = (value?: number | string | null): string => Math.trunc(Number(value ?? 0)).toString();
        const intValue1 = trunc(value1);
        const intValue2 = trunc(value2);

        const maxLength = Math.max(intValue1.length, intValue2.length);
        return this.getFontSize(Math.max(4, Math.min(maxLength, 9)) as FontSizeIndex);
    }

    private getFontSize(index: FontSizeIndex): string {
        return this.isMobile ? this.FONT_SIZE_STEPS.mobile[index] : this.FONT_SIZE_STEPS.desktop[index];
    }
}
